import { Controller } from "@hotwired/stimulus"

// Opens a preview URL inside a modal <iframe> — the Civic Warmth replacement
// for the old Bootstrap #iframe-modal (email/newsletter previews render a full
// HTML document, so they need an iframe, not a Turbo frame).
//
// Wire a trigger anywhere inside the controller scope:
//   <a href="<preview_url>"
//      data-action="iframe-dialog#open"
//      data-iframe-dialog-title-param="Newsletter Preview">Preview</a>
// The href is used as the iframe src (falls back to a url param if given).
export default class extends Controller {
  static targets = ["dialog", "frame", "title"]

  open(event) {
    event.preventDefault()
    const src = event.params.url || event.currentTarget.getAttribute("href")
    if (!src) return
    this.frameTarget.src = src
    if (this.hasTitleTarget) {
      this.titleTarget.textContent = event.params.title || "Preview"
    }
    this.dialogTarget.showModal()
  }

  close() {
    this.dialogTarget.close()
  }

  // Close when the backdrop (the dialog element itself) is clicked. Clicks
  // inside the iframe don't bubble across the frame boundary, so this only
  // fires for the surrounding backdrop.
  backdrop(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  // Reset on close (Esc, backdrop, or button) so the next open starts blank
  // and a heavy email preview isn't kept alive in the background.
  reset() {
    this.frameTarget.src = "about:blank"
  }
}
